export const markLinksFromString = (string) =>
    string.replace(
        /<a\s+([^<]*\s)?href="(?!https?:\/\/|mailto:|tel:)[^"]+".*?>.*?<\/a>/g,
        (match) => match.replace(/^<a/, "<a data-internal-link-from-string='true'")
    );
